export const timer = (ms) => new Promise((res) => setTimeout(res, ms));